// Lib
import * as _ from 'lodash';
import { put, call, takeLatest, debounce } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetLMOperationHoursAPI, getLMOperationHoursAPIError, getLMOperationHoursAPISuccess, ActionPostLMOperationHoursAPI, postLMOperationHoursAPIError, postLMOperationHoursAPISuccess } from './actions';
import { LMoperationHours } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPILMoperationHours } from './utils';

function* getDealerLMoperationHours(action: ActionGetLMOperationHoursAPI) {
  try {
    const { listingId } = action;
    const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/operationhours`);
    const lmoperationHours: LMoperationHours = parseAPILMoperationHours(data);
    yield put(getLMOperationHoursAPISuccess(lmoperationHours));
  } catch (err) {
    yield put(getLMOperationHoursAPIError());
  }
}

function* postDealerLMOperationHours(action: ActionPostLMOperationHoursAPI) {
  try {
    const { listingId, operationHours } = action;
    const response = yield call(createAPINetworkInstance().post, `listing/${listingId}/operationhours`, operationHours);
    const lmoperationHours: LMoperationHours = parseAPILMoperationHours(response.data);
    yield put(postLMOperationHoursAPISuccess(lmoperationHours));
  } catch (err) {
    yield put(postLMOperationHoursAPIError());
  }
}

export default function* EngineOperationHourSagas() {
  yield takeLatest(ACTIONS.GET_LMOPERATIONHOURS_API_REQUEST, getDealerLMoperationHours);
  yield takeLatest(ACTIONS.POST_LMOPERATIONHOURS_API_REQUEST, postDealerLMOperationHours);
}